/*
 * the regular modal is handled by Bootstrap's Modal
 *
 * this is a variant of the modal, where the main is turned into a modal.
 * generally used when the user does not input an iban and does click submit.
 * the page will then turn into a 'modal', prompting the user to input the iban.
 *
 * GDL Requirements
 * - if the user does not input iban, and does submit, the page should show as a modal. the page should not yet be validated until the next submit.
 *
 */

const modalMain = () => {
  const settings = {
    triggerSelector: '.js-main-modal-trigger',
    elementsToShowSelector: '.js-main-modal-hidden-element',
    elementsToHideSelector: '.js-main-modal-visible-element',
    buttonElementsToShowSelector: '.js-main-modal-hidden-element-submit',
    buttonElementsToHideSelector: '.js-main-modal-visible-element-button',
    inputErrorClass: 'input-validation-error',
    fieldErrorClass: 'field-validation-error',
    validClass: 'valid',
    scrollToTopSpeed: 100,
    scrollToModalSpeed: 0,
    modalSelector: '.main',
  };

  if ($(settings.triggerSelector).length === 0) {
    return;
  }

  const pageHasErrors = () => {
    return $('input.input-validation-error').length > 0;
  };

  const scrollToTop = () => {
    $('html,body').animate({ scrollTop: 0 }, settings.scrollToTopSpeed);
  };

  const scrollToModal = () => {
    if (settings.modalSelector !== undefined) {
      const scrollTo = window.findPos($(`${settings.modalSelector}:visible`)[0]);
      scrollTo[0] -= 8;
      $('html,body').animate({ scrollTop: scrollTo }, settings.scrollToModalSpeed);
    } else {
      scrollToTop();
    }
  };

  $(settings.triggerSelector).on('click', function handleClick(evt) {
    evt.preventDefault();
    const isOpen = $('main').attr('id') === 'modal-main';

    if (isOpen) {
      /* Turn the main into a 'modal' */
      $('body')
        .removeClass('modal-open')
        .removeClass('modal-main-open');
      $('main').attr('id', '');
      $('main').attr('data-toggle', '');
      $('main').attr('data-target', '');
      $('#modal-main')
        .removeClass('modal')
        .removeClass('fade')
        .removeClass('show');
      $('.modal-backdrop').removeClass('show');

      /* Hide elements to hide */
      $(settings.elementsToHideSelector).show();
      $(settings.buttonElementsToHideSelector).hide();

      /* Show elements to hide */
      $(settings.elementsToShowSelector).hide();
      $(settings.buttonElementsToShowSelector).show();
      $('.modal-backdrop').remove();
      scrollToTop();
    } else {
      /*
             * If the user has inputted all fields on the page, submit
             * else turn main into a modal
             * and show/hide appropriate elements.
             */
      let shouldSubmit = true;
      /* Function is declared in virtualpaging.js */
      const inputsToCheck = window.inputsToCheck(); // FIX WINDOW FUNCTION!
      if (inputsToCheck.length > 0) {
        /* If there are any empty fields or unchecked checks that are not optional */
        for (let i = 0; i < inputsToCheck.length; i += 1) {
          const $input = $(inputsToCheck[i]);
          if ($input.hasClass(settings.inputErrorClass)) {
            shouldSubmit = false;
          } else if ($(this).attr('data-val-required') !== undefined) {
            if ($input.attr('type') === 'radio' || $input.attr('type') === 'checkbox') {
              if (!$input.is('checked')) {
                shouldSubmit = false;
              }
            } else if ($input.val() === '') {
              shouldSubmit = false;
            }
          }
        }
      }
      if (shouldSubmit) {
        $('form').submit();
      }
      if (pageHasErrors()) {
        /* Turn the main into a 'modal' */
        $('body')
          .addClass('modal-open')
          .addClass('modal-main-open');
        $('main').attr('id', 'modal-main');
        $('main').attr('data-toggle', 'modal');
        $('main').attr('data-target', '#modal-main');
        $('#modal-main')
          .addClass('modal')
          .addClass('fade')
          .addClass('show')
          .show();

        /* Hide elements to hide */
        $(settings.elementsToHideSelector).hide();

        /* Show elements to hide */
        $(settings.elementsToShowSelector).show();

        scrollToModal();
      }
    }
  });
};

export default modalMain;
